// extracted by mini-css-extract-plugin
module.exports = {"item":"Internal_item__3a1qC","icon":"Internal_icon__1oMMs","disabled":"Internal_disabled__1WmxI","chevron":"Internal_chevron__2jM6l"};